import { sortDestinationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const reorderSortDestinations = {
  name: "reorderSortDestinations" as const,
  input: z.object({ destinationIds: z.array(sortDestinationIdFormat.schema) }),
  output: z.null(),
};
